import { useCallback } from 'react';

import type { ProductType } from '@sso/shared/constants';
import { Card, Button, Text } from '@sso/shared/core';

import { Container, Ul } from './ProductSelectCard.styles';
import { features } from './constants';
import Header from './Header';

type ProductSelectCardPros = {
    onSelect: (product: ProductType) => void;
    withFeatures?: boolean;
    product: ProductType;
    title: string;
    id: string;
};

function ProductSelectCard({ product, onSelect, title, id, withFeatures }: ProductSelectCardPros) {
    const selectProduct = useCallback(() => onSelect(product), [onSelect, product]);

    return (
        <Card id={id} p={4}>
            <Header product={product} />
            <Container>
                <div>
                    <Text as="p">{title}</Text>
                    {withFeatures && (
                        <Ul>
                            {features[product].map(feature => (
                                <li key={feature}>
                                    <Text size="textSm">{feature}</Text>
                                </li>
                            ))}
                        </Ul>
                    )}
                </div>
                <Button onClick={selectProduct} appearance="ghostBlue" mt={32}>
                    Select
                </Button>
            </Container>
        </Card>
    );
}

export default ProductSelectCard;
